import { render, staticRenderFns } from "./WorkflowFieldConfigure.vue?vue&type=template&id=28bf098f&scoped=true"
import script from "./WorkflowFieldConfigure.vue?vue&type=script&lang=js"
export * from "./WorkflowFieldConfigure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28bf098f",
  null
  
)

export default component.exports